import React, { useContext } from 'react'
import LeftContent from 'modules/react/signup/LeftContent'
import RightContent from 'modules/react/signup/RightContent'
import SignupContext from 'modules/react/signup/SignupContext'
import FormElementError from 'modules/react/signup/FormElementError'
import CourseSummary from 'modules/react/signup/CourseSummary'

export default function Step3Unemployed () {

  const signupContext = useContext(SignupContext)
  const { goBack, goToNextStep, setFormValue, submit, restUrls, setEnterCallback } = signupContext

  React.useEffect(() => {
      setEnterCallback(() => completeSignup)
    }, []
  )

  const completeSignup = () => {
    submit(restUrls.unemployed.signup)
      .then((response) => {
        goToNextStep()
      })
  }

  return (
    <>
      <LeftContent>
        <div className="title title--h3">Udfyld jobcenter oplysninger</div>
        <div className="wysiwyg">For at vi kan fuldføre din tilmelding (blanket AR237)
          har vi brug for at komme i kontakt med din sagsbehandler hos jobcenteret..
        </div>
        <div className="input-group">
          <div className="input-wrap">
            <FormElementError name="jobcenter">
              <input type="text" placeholder="Jobcenter*:"
                     onChange={(e) => setFormValue('jobcenter', e.target.value)}/>
            </FormElementError>
          </div>
          <div className="input-wrap">
            <FormElementError name="jobcenter_contact_person">
              <input type="text" placeholder="Kontaktperson:"
                     onChange={(e) => setFormValue('jobcenter_contact_person', e.target.value)}/>
            </FormElementError>
          </div>
          <div className="input-wrap">
            <FormElementError name="jobcenter_email">
              <input type="text" placeholder="Kontaktpersons email:"
                     onChange={(e) => setFormValue('jobcenter_email', e.target.value)}/>
            </FormElementError>
          </div>
          <div className="input-wrap">
            <FormElementError name="jobcenter_phone">
              <input type="text" placeholder="Kontaktpersons tlf:"
                     onChange={(e) => setFormValue('jobcenter_phone', e.target.value)}/>
            </FormElementError>
          </div>
        </div>
        <div className="button-section button-section--modal-group">
          <button className="inline-button inline-button--prim inline-button--back" onClick={goBack}>Tilbage</button>
          <button className="button button--next" onClick={completeSignup}>Tilmeld mig</button>
        </div>
      </LeftContent>
      <RightContent>
        <CourseSummary paymentType="Egenbetaling"/>
      </RightContent>
    </>
  )
}